import { TableCell as MUITableCell } from '@mui/material';

export const TableHeadCell = ({
  children,
  align = 'left',
  width = '200px',
  ...props
}) => {
  return (
    <MUITableCell
      className="!truncate !font-medium !text-[14px]/[20px] !text-base-1000 !text-nowrap !py-2 !px-3 !border-b !border-b-base-1000 !bg-neutral-100"
      align={align}
      style={{ width, minWidth: width, maxWidth: width }}
      {...props}
    >
      {children}
    </MUITableCell>
  );
};
